import * as React from 'react'
import { IconWithText } from '@components/icon-with-text'

interface Props {
  className?: string
}

export const SubscriptionWithBenefitCodeLabel = ({ className }: Props): JSX.Element => (
  <div className={className}>
    <div className="d-inline-block">
      <div className="subscription-with-benefits-owner__code-label">
        <IconWithText
          text={
            <span className="fw-semi-bold font-size-sm">
              Odblokowane <strong>Lokale Specjalne</strong>
            </span>
          }
          iconClassName="uil-tag-alt me-2 lh-1"
          wrapperClassName="text-white me-auto"
          textClassName="font-size-sm lh-1"
        />
      </div>
    </div>
  </div>
)
